import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment";
import toast from "react-hot-toast";
import FileSaver from "file-saver";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Styles from "./SubscriptionHistory.module.css";
import {
  base64DownloadService,
  listSubscriptionHistoryService,
  viewSubscriptionHistoryService,
} from "../../../Services/ApiServices";
import LeftArrow from "../../../Assets/modal_left_arrow.png";
import RightArrow from "../../../Assets/modal_right_arrow.png";
import viewIcon from "../../../Assets/view.svg";
import Loader from "../../../SharedComponents/Loader/Loader";
import download from "../../../Assets/download.png";
import searchIcon from "../../../Assets/searchFilter.png";
import shareIcon from "../../../Assets/share.svg";
import { Confirmation } from "../../../Modal/Confirmation";
import {
  base64ToBlob,
  parseBase64Response,
  planActiveText,
} from "../../../Utility/Utility";
import ViewSubscriptionHistory from "./ViewSubscriptionHistory";

export default function SubscriptionHistory() {
  let navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(0);
  const [isShowViewDetailsModal, setisShowViewDetailsModal] = useState(false);
  const [viewId, setViewId] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    invoiceNumber: "",
  });
  const [viewData, setviewData] = useState(null);

  useEffect(() => {
    listSubscriptionHistoriesApiCall();
  }, []);

  const listSubscriptionHistoriesApiCall = (
    pageNum = 1,
    appliedFilter = filterData,
  ) => {
    setIsLoader(true);
    let formData = new FormData();
    formData.append("invoice_no", appliedFilter?.invoiceNumber);

    if (appliedFilter?.fromDate) {
      formData.append(
        "from_date",
        dayjs(appliedFilter?.fromDate).format("YYYY-MM-DD"),
      );
    }
    if (appliedFilter?.toDate) {
      formData.append(
        "to_date",
        dayjs(appliedFilter?.toDate).format("YYYY-MM-DD"),
      );
    }

    listSubscriptionHistoryService(formData, pageNum, 10)
      .then((res) => {
        setTableData({
          ...res.data,
          items: res.data?.items,
        });
        setPage(pageNum - 1);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Data Not Found !!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleReset = () => {
    setFilterData({
      fromDate: "",
      toDate: "",
      invoiceNumber: "",
    });
    listSubscriptionHistoriesApiCall(1, {
      fromDate: "",
      toDate: "",
      invoiceNumber: "",
    });
  };

  const viewDownloadSubscriptionHistoryApiCall = (id, isDownload) => {
    setIsLoader(true);
    const formData = new FormData();
    formData.append("plan_subscribed_id", id);
    formData.append("download", isDownload ? 1 : 0);
    viewSubscriptionHistoryService(formData)
      .then((res) => {
        if (isDownload) {
          let url = res.data?.data?.invoice_url;
          let urlArr = url.split(".");
          let ext = urlArr[urlArr.length - 1];
          let dateTime =
            moment().format("DD-MM-YYYY") + "," + moment().format("hh:mm:ss a");
          let fileName = dateTime + "." + ext;
          FileSaver.saveAs(url, fileName);
        } else {
          setviewData(res.data.data);
          setisShowViewDetailsModal(true);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleShareSubscriptionInvoice = async (item) => {
    const invoiceNo = item?.invoice_number || "";
    const planTitle = item?.plan_title || "";
    const shareTitle = invoiceNo
      ? `Subscription Invoice #${invoiceNo}`
      : "Subscription Invoice";
    const shareText = `Subscription Invoice${
      invoiceNo ? ` #${invoiceNo}` : ""
    }${planTitle ? ` - ${planTitle}` : ""}`;
    let fileName = `${
      invoiceNo ? `Subscription_Invoice_${invoiceNo}` : "Subscription_Invoice"
    }.pdf`;

    setIsLoader(true);
    let url = "";
    let currentBlob = null;

    try {
      const planSubscribedId = item?.plan_subscribed_id;
      const res = await base64DownloadService(2, planSubscribedId);
      const {
        base64,
        fileName: sFileName,
        contentType: cType,
        url: resUrl,
      } = parseBase64Response(res);
      if (sFileName) {
        fileName = sFileName.toLowerCase().endsWith(".pdf")
          ? sFileName
          : `${sFileName}.pdf`;
      }
      if (resUrl) url = resUrl;
      if (base64) {
        currentBlob = base64ToBlob(base64, cType);
      }
    } catch (err) {
      console.warn("Base64 subscription invoice download failed, trying fallback:", err);
    }

    // Fallback: if no blob and no url, fetch via viewSubscriptionHistoryService
    if (!currentBlob && !url) {
      try {
        const formData = new FormData();
        formData.append("plan_subscribed_id", item?.plan_subscribed_id);
        formData.append("download", 1);
        const res = await viewSubscriptionHistoryService(formData);
        url = res?.data?.data?.invoice_url;
      } catch (err) {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Failed to load subscription invoice");
        }
        setIsLoader(false);
        return;
      }
    }
    setIsLoader(false);

    if (!url && !currentBlob) {
      toast.error("Invoice PDF not found!");
      return;
    }

    if (navigator.share) {
      // 1. Try sharing as a PDF file attachment first
      if (currentBlob) {
        try {
          const file = new File([currentBlob], fileName, {
            type: "application/pdf",
          });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({
              files: [file],
              title: shareTitle,
              text: shareText,
            });
            return;
          }
        } catch (err) {
          if (err?.name === "AbortError") {
            return;
          }
          console.warn("File share failed, falling back to URL share:", err);
        }
      }

      // 2. Fallback: share as URL if file sharing is not supported by browser
      if (url) {
        try {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: url,
          });
          return;
        } catch (err) {
          if (err?.name === "AbortError") {
            return;
          }
          console.error("Native share error:", err);
          toast.error("Unable to open share prompt");
          return;
        }
      }
    } else {
      if (url && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        toast.success("Invoice link copied to clipboard!");
      } else {
        toast.error(
          "Sharing is only supported on mobile devices with HTTPS or a supported browser."
        );
      }
    }
  };

  return (
    <div className={Styles.parentContainer + " container-fluid"}>
      <Loader isLoader={isLoader} />
      {isShowViewDetailsModal ? (
        <ViewSubscriptionHistory
          isShow={isShowViewDetailsModal}
          viewData={viewData}
          onHide={() => setisShowViewDetailsModal(false)}
        />
      ) : null}

      <div className={Styles.childContainerParent}>
        <div className={Styles.childContainer}>
          <div className={Styles.searchParentContainer}>
            <p className="fontBold">
              Subscription<span className="orange"> Invoice</span>
            </p>
            <img
              className={Styles.searchIcon}
              src={searchIcon}
              alt="search"
              onClick={() => setShowFilter((pre) => !pre)}
            />
          </div>
          {showFilter ? (
            <div className={Styles.filterParentContainer + " row"}>
              <div className={Styles.categories + " col-md-4 col-sm-12"}>
                <label className="label">Invoice No</label>
                <input
                  type="text"
                  placeholder="Invoice no"
                  className={Styles.filterInput + " contentFont"}
                  value={filterData.invoiceNumber}
                  onChange={(e) =>
                    setFilterData({
                      ...filterData,
                      invoiceNumber: e.target.value,
                    })
                  }
                />
              </div>
              <div className={Styles.categories + " col-md-4 col-sm-12"}>
                <label className="label">From Date</label>
                <DatePicker
                  value={filterData.fromDate}
                  className={Styles.filterInput + " contentFont"}
                  format={"DD/MM/YYYY"}
                  onChange={(val) => {
                    setFilterData({
                      ...filterData,
                      fromDate: val,
                    });
                    if (val > filterData.toDate) {
                      setFilterData((pre) => ({ ...pre, toDate: "" }));
                    }
                  }}
                />
              </div>
              <div className={Styles.categories + " col-md-4 col-sm-12"}>
                <label className="label">To Date</label>
                <DatePicker
                  value={filterData.toDate}
                  className={Styles.filterInput + " contentFont"}
                  format={"DD/MM/YYYY"}
                  disabledDate={(current) => {
                    return current < filterData.fromDate;
                  }}
                  onChange={(val) => {
                    setFilterData({
                      ...filterData,
                      toDate: val,
                    });
                  }}
                />
              </div>

              <div
                className={Styles.searchBtnContainer + " col-md-4 col-sm-12"}
              >
                <button
                  onClick={() => {
                    handleReset();
                  }}
                  className={Styles.resetBtn}
                >
                  Reset
                </button>
                <button
                  onClick={() => {
                    listSubscriptionHistoriesApiCall();
                  }}
                  className={Styles.searchBtn}
                >
                  Search
                </button>
              </div>
            </div>
          ) : null}
          <div className={Styles.tableParentContainer}>
            <div className={Styles.TableChildContainer}>
              <table>
                <thead>
                  <tr>
                    <th className={Styles.tableHead + " text-center "}>S.NO</th>
                    <th className={Styles.tableHead + " text-center "}>
                      Invoice No
                    </th>
                    <th className={Styles.tableHead + " text-center "}>
                      Plan Name
                    </th>
                    <th className={Styles.tableHead + " text-center "}>
                      Valid From
                    </th>
                    <th className={Styles.tableHead + " text-center "}>
                      Valid To
                    </th>
                    <th className={Styles.tableHead + " text-center "}>
                      No. of Days
                    </th>
                    <th className={Styles.tableHead + " text-center "}>
                      No. of Products
                    </th>
                    <th className={Styles.tableHead + " text-center "}>
                      Total Price
                    </th>

                    <th className={Styles.actionTableHead + " text-center "}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.items !== undefined &&
                    tableData?.items.length > 0 &&
                    tableData?.items?.map((e, index) => (
                      <tr key={e.product_id}>
                        <td className={Styles.th + " contentFont text-center"}>
                          {(tableData?.page - 1) * tableData?.size +
                            (index + 1)}
                        </td>
                        <td className={"contentFont text-center"}>
                          {e?.invoice_number ? e?.invoice_number : "-"}
                        </td>
                        <td className={"contentFont text-center"}>
                          {e?.plan_title ? e?.plan_title : "-"}
                        </td>
                        <td className="contentFont text-center">
                          {e?.valid_from
                            ? moment
                              .utc(e?.valid_from)
                              .local()
                              .format("DD-MM-YYYY hh:mm A")
                            : "-"}
                        </td>
                        <td className="contentFont text-center">
                          {e?.valid_to
                            ? moment
                              .utc(e?.valid_to)
                              .local()
                              .format("DD-MM-YYYY hh:mm A")
                            : "-"}
                        </td>
                        <td className="contentFont text-center">
                          {e?.no_of_days ? e.no_of_days : "-"}
                        </td>
                        <td className="contentFont text-center">
                          {e?.no_of_products ? e.no_of_products : "-"}
                        </td>
                        <td className="contentFont text-center">
                          {e?.total_price ? e.total_price : "-"}
                        </td>

                        <td className={Styles.actionTd + " contentFont text-center"}>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip>View</Tooltip>}
                          >
                            <img
                              src={viewIcon}
                              alt="view"
                              className={Styles.viewImg}
                              onClick={() => {
                                viewDownloadSubscriptionHistoryApiCall(
                                  e?.plan_subscribed_id,
                                );
                              }}
                            />
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip>Download</Tooltip>}
                          >
                            <img
                              src={download}
                              alt="download"
                              className={Styles.viewImgDownload}
                              onClick={() =>
                                viewDownloadSubscriptionHistoryApiCall(
                                  e?.plan_subscribed_id,
                                  true,
                                )
                              }
                            />
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip>Share</Tooltip>}
                          >
                            <img
                              src={shareIcon}
                              alt="share"
                              className={Styles.viewImgShare}
                              onClick={() =>
                                handleShareSubscriptionInvoice(e)
                              }
                            />
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}

                  {tableData?.items?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={7}
                        className="fs-6 text-secondary text-center p-3"
                      >
                        Data Not Found
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>

          <div
            style={{ display: tableData?.total <= 10 ? "none" : "block" }}
            className={Styles.paginationContainer}
          >
            <ReactPaginate
              previousLabel={<img src={LeftArrow} alt="left" />}
              nextLabel={<img src={RightArrow} alt="right" />}
              breakLabel="..."
              pageCount={Math.ceil(tableData.total) / 10}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={({ selected }) =>
                listSubscriptionHistoriesApiCall(selected + 1)
              }
              containerClassName={
                "pagination m-0 d-flex justify-content-end me-4 bg-secondory"
              }
              pageClassName={"page-item"}
              pageLinkClassName={
                "page-link text-secondary rounded-circle bg-light pt-1 pb-1 ps-2 pe-2 ms-1 me-1 border-0 shadow-none"
              }
              forcePage={page}
              previousClassName={"page-item"}
              previousLinkClassName={
                "page-link border-0 text-dark p-1 rounded-circle bg_orange shadow-none me-1"
              }
              nextClassName={"page-item "}
              nextLinkClassName={
                "page-link border-0 text-dark p-1 bg_orange rounded-circle shadow-none ms-1"
              }
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
